import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/moment4.webp")